
import type { PropType } from 'vue';

import {
  defineComponent,
  computed,
  ref,
} from 'vue';

import PrimeVueInputNumber from 'primevue/inputnumber';

import PrimeVueMultiSelect from 'primevue/multiselect';

import PrimeVueSkeleton from 'primevue/skeleton';

import type { GenericObject } from '@/types';

export default defineComponent({
  components: {
    PrimeVueInputNumber,
    PrimeVueMultiSelect,
    PrimeVueSkeleton,
  },
  props: {
    modelValue: {
      type: Array as PropType<GenericObject[]>,
      required: true,
    },
    options: {
      type: Array as PropType<GenericObject[]>,
      default: () => [],
    },
    optionValue: {
      type: String,
      default: 'id',
    },
    optionLabel: {
      type: String,
      default: 'name',
    },
    optionsLoading: {
      type: Boolean,
      default: false,
    },
  },
  emits: [
    'update:modelValue',
    'previewCreative',
  ],
  setup(props, { emit }) {
    const creatives = computed({
      get: () => props.modelValue,
      set: (value: GenericObject[]) => {
        emit('update:modelValue', value.filter((creative: GenericObject) => !!creative.creative_id));
      },
    });

    const availableOptions = computed(() => props.options.filter(
      (option) => !creatives.value.some((item) => item.creative_id === option[props.optionValue]),
    ));

    const getLabel = (creativeId: number): string => {
      const option = props.options.find((item) => item[props.optionValue] === creativeId);

      return option ? option[props.optionLabel] : String(creativeId);
    };

    const deleteCreative = (index: number): void => {
      creatives.value.splice(index, 1);
    };

    const selectedIds = ref<number[]>([]);

    const addSelected = (): void => {
      selectedIds.value.forEach((id: number) => {
        creatives.value.push({
          creative_id: id,
          weight: 100,
        });
      });

      selectedIds.value = [];
    };

    return {
      creatives,
      availableOptions,
      getLabel,
      deleteCreative,
      selectedIds,
      addSelected,
    };
  },
});
